import { Component, Input, AfterViewInit, OnDestroy } from '@angular/core';

export interface CarouselSlide {
  imageUrl: string;
  title: string;
  description: string;
}

declare var bootstrap: any;

@Component({
  selector: 'app-carousel1',
  templateUrl: './carousel1.component.html',
  styleUrls: ['./carousel1.component.scss']
})
export class Carousel1Component implements AfterViewInit, OnDestroy {

  @Input() slides: CarouselSlide[] = [];
  @Input() titleColor = '#fff';
  @Input() descriptionColor = '#fff';
  
  private carouselInstance: any;

  ngAfterViewInit(): void {
    this.initCarousel();
  }

  ngOnChanges(): void {
    // re-init if slides change dynamically
    setTimeout(() => this.initCarousel());
  }

  private initCarousel(): void {
    if (!this.slides?.length) return;

    const element = document.getElementById('carousel1');

    if (element && (window as any).bootstrap) {
      this.carouselInstance = bootstrap.Carousel.getOrCreateInstance(element, {
        interval: 3000,
        pause: false,
        wrap: true
      });

      this.carouselInstance.cycle();
    }
  }

  ngOnDestroy(): void {
    if (this.carouselInstance) {
      this.carouselInstance.dispose();
    }
  }

  trackByIndex(index: number): number {
    return index;
  }
}